import { CustomerService } from 'src/app/angularJS/services/customer/customer.service';
import { DialogService } from 'src/app/angularJS/services/dialog/dialog.service';
import { EntitlementValidationService } from "src/app/angularJS/services/entitlement-validation/entitlement-validation.service";
import { LinkBuilder } from 'src/app/angularJS/services/link-builder.service';
import { ProductService } from "src/app/angularJS/services/product/product.service";
import { QueryBuilder } from 'src/app/angularJS/services/query-builder.service';
import { BreadcrumbService } from "../../../services/breadcrumbs/breadcrumb.service";
import { CustomerDetailsService } from "../../../services/customer-detail/customer-detail.service";
import { UserMessagesService } from "../../../services/user-messages.service";
import Product = InterACT.Interfaces.Catalogues.Product;

export class CustomerEntitlementsController {
  public static $inject = ['customer', 'customerService', 'customerDetailService', 'breadcrumbService', 'QueryBuilder', '$q', 'dialogService', '$state', 'PrimaryAction', 'productService', 'UserMessages', 'LinkBuilder', 'entitlementValidationService'];

  public entitlements: Array<InterACT.Interfaces.Entitlements.Entitlement>;
  public entitlementRequests: Array<InterACT.Interfaces.Entitlements.EntitlementRequest>;
  public entitlementRequestDataToDisplay: InterACT.Interfaces.Entitlements.Entitlement;
  public expandedEntitlementRequestData: InterACT.Interfaces.Entitlements.Entitlement;
  public enhancedDetails: any;
  public customer: InterACT.Interfaces.Customers.Customer;
  public resendVerificationEmailButtonEnabled: boolean;
  public entitlementsPaginator: InterACT.Interfaces.IPaginationData = {
    currentPage: 1,
    perPageCount: 15,
    totalCount: 0
  };
  public entitlementRequestsPaginator: InterACT.Interfaces.IPaginationData = {
    currentPage: 1,
    perPageCount: 15,
    totalCount: 0
  };
  public today = new Date();

  constructor(customer: InterACT.Interfaces.Customers.Customer,
    private customerService: CustomerService,
    private customerDetailService: CustomerDetailsService,
    private breadcrumbService: BreadcrumbService,
    private queryBuilder: QueryBuilder,
    private $q: ng.IQService,
    private dialogService: DialogService,
    private $state: ng.ui.IStateService,
    private PrimaryAction: any,
    private productService: ProductService,
    private UserMessages: UserMessagesService,
    private linkBuilder: LinkBuilder,
    private entitlementValidationService: EntitlementValidationService) {

    this.enhancedDetails = {};
    this.customer = angular.copy(customer);
    this.activate();
  }


  /**
   * A method which is used to instantiate the controller
   */
  private activate() {

    if (this.customer.id) {

      this.enhancedDetails = this.customerDetailService.getEnhancedCustomerData(this.customer);
      const fullName = this.enhancedDetails && this.enhancedDetails.fullName ? this.enhancedDetails.fullName : 'CUSTOMER_TABS.ENTITLEMENTS';
      this.breadcrumbService.setBreadcrumbs([
        {
          name: 'SEARCH',
          sref: 'customers'
        }, {
          name: fullName,
          sref: 'customer.details',
          options: {
            reload: 'customer'
          }
        }, {
          name: 'CUSTOMER_TABS.ENTITLEMENTS',
          sref: 'customer.entitlements'
        }
      ]);

      this.PrimaryAction.setActions([{
        name: 'Create entitlement',
        icon: 'add',
        action: this.onAddEntitlementClick
      }]);

      this.getEntitlements(this.entitlementsPaginator.currentPage, this.entitlementsPaginator.perPageCount);
      this.getEntitlementRequests(this.entitlementRequestsPaginator.currentPage, this.entitlementRequestsPaginator.perPageCount);

      this.resendVerificationEmailButtonEnabled = true;
    }
  }

  public getAssignableProducts() {
    const sortInstr = [
      <InterACT.Interfaces.ISortInstruction>{ columnName: 'link ', direction: 'DESC' }
    ];
    let productSearchQuery = this.queryBuilder.newParam()
      .fieldIs('type', 'VARIANT')
      .and()
      .fieldIs('scheme.link', this.customer.scheme.link)
      .and()
      .fieldContains('tags', 'ENTITLEMENT')
      .and()
      .fieldIs('status', 'AUTHORISED')
      .sortBy(sortInstr).getParam();

    return this.customerService.getProducts(1, 10000, productSearchQuery, true);
  }

  private filterResults(results: Array<InterACT.Interfaces.ProductSearch.SearchResult>) {

    function filterNonActive(item: InterACT.Interfaces.ProductSearch.SearchResult) {
      const now = new Date();

      const effectiveFromFlag = item.effectiveFrom != null && new Date(item.effectiveFrom) <= now;
      const effectiveToFlag = item.effectiveTo == null || new Date(item.effectiveTo) > now;

      return effectiveFromFlag && effectiveToFlag;
    }

    // Filter expired catalogues first
    var filteredResult = results.filter(item => filterNonActive(item));

    // Read catalogue links to take latest versions
    let map = new Map();
    for (let result of filteredResult) {
      let hasCatVersion = result.link.indexOf('?catalogueVersion=') !== -1;
      let catSplit = result.link.split('?catalogueVersion=')
      const catalogueVersion = hasCatVersion ? parseInt(catSplit[1]) : 0;
      const normalisedLink = hasCatVersion ? catSplit[0] : result.link;

      if (map.get(normalisedLink) == undefined || catalogueVersion > map.get(normalisedLink)) {
        map.set(normalisedLink, catalogueVersion);
      }
    }

    function retainedEntry(link: string) {
      for (let entry of map.entries()) {
        let entryLink = `${entry[0]}?catalogueVersion=${entry[1]}`
        if (entryLink == link) {
          return true;
        }
      }
      return false;
    }

    // Filter older catalogue versions
    return filteredResult.filter(item => retainedEntry(item.link));
  }

  public getEntitlements(page: number, perPage: number) {
    const sortInstr = [
      <InterACT.Interfaces.ISortInstruction>{ columnName: 'status', direction: 'ASC' },
      <InterACT.Interfaces.ISortInstruction>{ columnName: 'validity.endDateTime', direction: 'DESC' }
    ];

    let entitlementsQuery;

    if (this.customer && this.customer.id) {
      entitlementsQuery = this.queryBuilder.newParam().customerLinkIs(this.customer.id).sortBy(sortInstr).getParam();


      this.customerService.getEntitlements(page, perPage, entitlementsQuery).then((entitlementsResponse) => {
        this.entitlements = entitlementsResponse.entitlements;
        this.entitlementsPaginator.totalCount = this.entitlements.length;

        // Look at the validity of all entitlements for a customer and update the status of any which have expired
        const now: Date = new Date();
        for (const entitlement of this.entitlements) {
          if (entitlement.validity && entitlement.validity.endDateTime) {
            const expiry: Date = new Date(entitlement.validity.endDateTime);
            if (expiry < now) {
              (<any>entitlement).status = 'EXPIRED';
            } else if (entitlement.verificationStatus && 'SUCCESS' != entitlement.verificationStatus) {
              (<any>entitlement).status = entitlement.verificationStatus;
            }
          }
        }
      });
    }
  }

  private getVariantDataFromCatalogueLink(link: string) {
    const linkParts = link.split('/');
    const catalogueId = linkParts[2];
    const productId = linkParts[4];
    const variantIdWithQueryString = linkParts[6];
    const catalogueVersion = variantIdWithQueryString.indexOf('?catalogueVersion=') !== -1 ? parseInt(variantIdWithQueryString.split('?catalogueVersion=')[1]) : null;
    const options = catalogueVersion ? { catalogueVersion: catalogueVersion, expand: true } : { expand: true };
    const variantId = variantIdWithQueryString
      .indexOf('?catalogueVersion=') !== -1 ? parseInt(variantIdWithQueryString.split('?catalogueVersion=')[0]) : parseInt(variantIdWithQueryString);

    return this.productService.getProduct(catalogueId, parseInt(productId), options)
      .then((product) => {
        return this.getVariant(product, variantId);
      });
  }

  public getVariant(product: Product, variantId: number) {
    let productVariant;
    let mergedFieldsMap;
    let mergedData;

    if (product.variants !== undefined && product.variants != null) {
      productVariant = product.variants.find(v => v.id === variantId);
      mergedData = new Map([...new Map(Object.entries(product)), ...new Map(Object.entries(productVariant))])
      mergedFieldsMap = new Map([...new Map(Object.entries(product.fields)), ...new Map(Object.entries(productVariant.fields))]);

      const mergedFieldsObject = Array.from(mergedFieldsMap).reduce((obj, [key, value]) => {
        obj[key] = value;
        return obj;
      }, {});

      return {
        id: mergedData.get('id'),
        name: mergedData.get('name'),
        description: mergedData.get('description'),
        type: mergedData.get('type'),
        retailReference: mergedData.get('retailReference'),
        price: mergedData.get('price'),
        fields: mergedFieldsObject,
        tags: mergedData.get('tags'),
        channels: mergedData.get('channels')

      };
    }
    return product;
  }

  public onAddEntitlementClick = () => {
    const deferred = this.$q.defer();
    const now = moment();
    const tomorrow = moment(now).add(1, 'y');

    // Create a DTO for the fields to be bound to the dialog inputs
    const entitlementDlgBackingFields = {
      catalogueProduct: undefined,
      startDateTime: now.toDate(),
      startTime: now.format("HH:mm"),
      endDateTime: tomorrow.toDate(),
      endTime: tomorrow.format("HH:mm"),
      externalReference: undefined,
      issuer: undefined
    }

    this.getAssignableProducts().then((searchResultsResponse: any) => {

      let entitlementDlgProducts = this.filterResults(searchResultsResponse);
      const parent = this;

      this.dialogService.showDialog(
        'Add Entitlement',
        'entitlement-add-dialog.html',
        {
          entitlement: entitlementDlgBackingFields,
          assignableEntitlementProducts: entitlementDlgProducts,
          setSelectedCatalogueItem(catalogueProduct: string) {

            for (const assignableProduct of this.assignableEntitlementProducts) {
              if (assignableProduct.link === catalogueProduct) {
                parent.getVariantDataFromCatalogueLink(catalogueProduct).then((variant) => {

                  const startDateExpression = CustomerEntitlementsController.toMomentDateTime(variant.fields.startDateTime);
                  const endDateExpression = CustomerEntitlementsController.toMomentDateTime(variant.fields.endDateTime);

                  this.entitlement.startDateTime = startDateExpression.toDate();
                  this.entitlement.startTime = startDateExpression.format("HH:mm");
                  this.entitlement.endDateTime = endDateExpression.toDate();
                  this.entitlement.endTime = endDateExpression.format("HH:mm");
                });
                break;
              }
            }
          }
        },
        'entitlement-add-dialog'
      ).then((requestedEntitlement: any) => {

        parent.createEntitlementRequest(requestedEntitlement)
      });

      deferred.resolve();
    });

    return deferred.promise;
  }

  /**
   * This method attempts to create an entitlement request as a result of the user choosing an entitlement on screen
   * and clicking save. The input to the method contains the catalogue link for the requested entitlement as well as
   * validity details (start/end dates).
   * @param requestedEntitlement details of the entitlement to be requested
   * @private
   */
  private createEntitlementRequest(requestedEntitlement: any) {
    this.getVariantDataFromCatalogueLink(requestedEntitlement.catalogueProduct).then((variant) => {

      let schemeLink = { abbreviation: this.customer.scheme.abbreviation, link: this.customer.scheme.link };
      let customerLink = { link: this.linkBuilder.getCustomersLink(this.customer.id) };
      let catalogueLink = {
        name: variant.name,
        link: requestedEntitlement.catalogueProduct.split('?')[0]
      };
      let entitlementValidity = {
        startDateTime: CustomerEntitlementsController.compileDateTimeParts(requestedEntitlement.startTime, requestedEntitlement.startDateTime),
        endDateTime: CustomerEntitlementsController.compileDateTimeParts(requestedEntitlement.endTime, requestedEntitlement.endDateTime)
      };

      let entitlement: InterACT.Interfaces.Entitlements.Entitlement = {
        reference: variant.fields.type,
        scheme: schemeLink,
        customer: customerLink,
        status: "ACTIVE",
        technology: variant.fields.technology,
        externalReference: requestedEntitlement.externalReference,
        issuer: requestedEntitlement.issuer,
        validity: entitlementValidity,
        catalogueItem: catalogueLink,
      };

      let entitlementRequest: InterACT.Interfaces.Entitlements.EntitlementRequest = {
        entitlementData: entitlement,
        scheme: schemeLink,
        customer: customerLink,
        type: "CREATE"
      };

      this.postEntitlementRequestAndCloseDialog(entitlementRequest)

    }).catch(() => this.UserMessages.showToast('TOAST_MESSAGE.ENTITLEMENT_REQUEST.CREATE_ERROR'));
  }

  private replaceEntitlementAndCloseDialog(entitlement: InterACT.Interfaces.Entitlements.Entitlement): void {
    this.customerService.updateEntitlement(entitlement.id, entitlement).then(() => {
      // Pick up refreshed entitlement data and update screen
      this.getEntitlements(this.entitlementsPaginator.currentPage, this.entitlementsPaginator.perPageCount);
      this.getEntitlementRequests(this.entitlementRequestsPaginator.currentPage, this.entitlementRequestsPaginator.perPageCount);

      // Call into customer.routes.ts to force the customer.entitlements flow to run again
      this.$state.go(this.$state.current, this.$state.params, { reload: 'customer.entitlements' })
        // Show popup success message
        .then(() => this.UserMessages.showToast('TOAST_MESSAGE.ENTITLEMENT_REQUEST.UPDATE_SUCCESS'));

    }).catch(() => this.UserMessages.showToast('TOAST_MESSAGE.ENTITLEMENT_REQUEST.UPDATE_ERROR'));
  }


  private postEntitlementRequestAndCloseDialog(entitlementRequest: InterACT.Interfaces.Entitlements.EntitlementRequest) {
    this.customerService.createEntitlementRequest(entitlementRequest).then(() => {

      // Pick up refreshed entitlement data and update screen
      this.getEntitlements(this.entitlementsPaginator.currentPage, this.entitlementsPaginator.perPageCount);
      this.getEntitlementRequests(this.entitlementRequestsPaginator.currentPage, this.entitlementRequestsPaginator.perPageCount);

      // Call into customer.routes.ts to force the customer.entitlements flow to run again
      this.$state.go(this.$state.current, this.$state.params, { reload: 'customer.entitlements' })
        // Show popup success message
        .then(() => this.UserMessages.showToast('TOAST_MESSAGE.ENTITLEMENT_REQUEST.CREATE_SUCCESS'));

    }).catch(() => this.UserMessages.showToast('TOAST_MESSAGE.ENTITLEMENT_REQUEST.CREATE_ERROR'));
  }

  /**
   * Takes a date string and translates it into a moment date object. The method starts by assuming
   * the date string is a fixed date and if this fails assumes the date is an expression. If all the
   * translation attempts fail, moment returns a date of now.
   *
   * @param dateTime Could be a fixed date i.e. 2020-01-01 or expression i.e P1Y
   * @private
   */
  private static toMomentDateTime(dateTime) {
    let momentDateTime = moment(dateTime);
    if (!momentDateTime.isValid()) {
      momentDateTime = moment().add(moment.duration(dateTime));
    }
    return momentDateTime;
  }

  public getEntitlementRequests(page: number, perPage: number) {
    const sortInstr = [
      <InterACT.Interfaces.ISortInstruction>{ columnName: 'created', direction: 'DESC' }
    ];

    let entitlementRequestsQuery;

    if (this.customer && this.customer.id) {
      entitlementRequestsQuery = this.queryBuilder.newParam().entitlementDataCustomerLinkIs(this.customer.id)
        .and().not().statusIs('SUCCESS')
        .sortBy(sortInstr).getParam();


      this.customerService.getEntitlementRequests(page, perPage, entitlementRequestsQuery).then((entitlementRequestsResponse) => {
        this.entitlementRequests = entitlementRequestsResponse.entitlementRequests;
        this.entitlementRequestsPaginator.totalCount = this.entitlementRequests.length;
      });
    }
  }

  /**
   * @description A method which is used to toggle entitlement request details
   *
   * @param index The row index
   * @param entitlement data to display
   */
  public togglePanel(entitlementData: InterACT.Interfaces.Entitlements.Entitlement) {
    if (this.expandedEntitlementRequestData === entitlementData) {
      this.expandedEntitlementRequestData = undefined;
    } else {
      this.expandedEntitlementRequestData = entitlementData;
      this.entitlementRequestDataToDisplay = entitlementData;
    }
  }

  public showValidationErrorsDialog(entitlementRequest: InterACT.Interfaces.Entitlements.EntitlementRequest) {
    const validationErrors = entitlementRequest.validationErrors;
    const dialogTitle = entitlementRequest.entitlementData.catalogueItem.name ? this.capitalise(entitlementRequest.entitlementData.catalogueItem.name) : 'Entitlement '
    this.dialogService.showDialog(dialogTitle + 'Request Errors',
      'entitlement-request-failures-dialog.html',
      { validationErrors: validationErrors },
      'entitlement-request-failures-dialog')
  }

  // Can't find a way to capitalise the string on the html side as the title is passed to the general dialog controller
  public capitalise(words: string) {
    let capitalisedWords = '';
    words.split(' ').forEach((word) =>
      capitalisedWords += word[0].toUpperCase() + word.substr(1).toLowerCase() + ' ');
    return capitalisedWords;
  }

  public onEntitlementClick = (entitlement: InterACT.Interfaces.Entitlements.Entitlement) => {
    const deferred = this.$q.defer();

    this.customerService.getEntitlement(entitlement.id).then((latest) => {

      // Create a DTO for the fields to be bound to the dialog inputs
      const entitlementUpdate = {
        status: latest.status,
        verificationStatus: latest.verificationStatus,
        startDateTime: moment(latest.validity.startDateTime).toDate(),
        startTime: moment(latest.validity.startDateTime).format("HH:mm"),
        endDateTime: moment(latest.validity.endDateTime).toDate(),
        endTime: moment(latest.validity.endDateTime).format("HH:mm"),
        externalReference: latest.externalReference,
        issuer: latest.issuer
      }

      // Strict HH:mm regex for the dialog time fields
      const regexTimePattern = '([01]?[0-9]{1}|2[0-3]{1}):[0-5]{1}[0-9]{1}';
      let skipValidation: Boolean = false;

      this.dialogService.showDialog(
        latest.catalogueItem === null || !latest.catalogueItem.name
          ? 'Edit Entitlement'
          : 'Edit Entitlement - ' + latest.catalogueItem.name,
        'entitlement-edit-dialog.html',
        {
          entitlementUpdate: entitlementUpdate,
          regexTimePattern: regexTimePattern,
          skipValidation,
          statuses: ['PENDING', 'ACTIVE', 'BLOCKED', 'DELETED', 'HOTLISTED'],
          verificationStatuses: ['PENDING_VERIFICATION', 'PENDING_REVERIFICATION', 'SUCCESS', 'FAILED']
        },
        'entitlement-edit-dialog'
      ).then((options: any) => {
        if (options && options.entitlementUpdate) {
          latest.status = options.entitlementUpdate.status ? options.entitlementUpdate.status : latest.status;
          latest.verificationStatus = options.entitlementUpdate.verificationStatus ? options.entitlementUpdate.verificationStatus : latest.verificationStatus;
          latest.validity.startDateTime =
            CustomerEntitlementsController.compileDateTimeParts(options.entitlementUpdate.startTime, options.entitlementUpdate.startDateTime);
          latest.validity.endDateTime =
            CustomerEntitlementsController.compileDateTimeParts(options.entitlementUpdate.endTime, options.entitlementUpdate.endDateTime);
          latest.externalReference = options.entitlementUpdate.externalReference;
          latest.issuer = options.entitlementUpdate.issuer;
          if (options.skipValidation) {
            this.replaceEntitlementAndCloseDialog(latest);
          } else {
            this.postEntitlementRequestAndCloseDialog(this.createUpdateEntitlementRequest(latest));
          }
        }
        deferred.resolve();
      });
    });

    return deferred.promise;
  }

  private static compileDateTimeParts(time, dateTime) {
    let timeHourMinuteParts = time.split(':');
    return moment(dateTime).set({ h: timeHourMinuteParts[0], m: timeHourMinuteParts[1] }).format();
  }

  private createUpdateEntitlementRequest(updatedEntitlementData: InterACT.Interfaces.Entitlements.Entitlement) {

    let schemeLink = { abbreviation: this.customer.scheme.abbreviation, link: this.customer.scheme.link };
    let customerLink = { link: this.linkBuilder.getCustomersLink(this.customer.id) };

    let entitlementRequest: InterACT.Interfaces.Entitlements.EntitlementRequest = {
      entitlementData: updatedEntitlementData,
      scheme: schemeLink,
      customer: customerLink,
      type: "UPDATE",
      entitlementLink: this.linkBuilder.getEntitlementsLink(updatedEntitlementData.id)
    };

    return entitlementRequest;
  }

  public compareEntitlements(entitlementRequest: InterACT.Interfaces.Entitlements.EntitlementRequest) {
    const originalEntitlement = this.entitlements.find(entitlement => entitlement.id === this.getIdFromLink(entitlementRequest.entitlementLink));
    this.dialogService.showDialog('Compare Entitlements',
      'entitlement-update-comparison-dialog.html',
      { originalEntitlement: originalEntitlement, updatedEntitlement: entitlementRequest.entitlementData },
      'entitlement-update-comparison-dialog');
  }

  public checkIfNotVerified(entitlement: InterACT.Interfaces.Entitlements.Entitlement) {
    return 'PENDING_VERIFICATION' === entitlement.verificationStatus ||
      'PENDING_REVERIFICATION' === entitlement.verificationStatus;
  }

  public sendReverificationEmail(entitlement: InterACT.Interfaces.Entitlements.Entitlement) {
    this.resendVerificationEmailButtonEnabled = false;
    this.entitlementValidationService.getList(1, 1, `customer.link='${entitlement.customer.link}'`).then(response => {
      const validationRequest = response
        .entitlementValidationRequests
        .filter(request => request.actions.filter(action => 'EMAIL_VERIFICATION' === action.type && 'PENDING' === action.status))
        .pop();

      const pendingEmailVerificationAction = (validationRequest.actions || [])
        .filter(action => 'EMAIL_VERIFICATION' === action.type && 'PENDING' === action.status)
        .pop();

      if (pendingEmailVerificationAction) {
        let resourceLink: InterACT.Interfaces.EntitlementValidation.ResourceLink = {
          link: pendingEmailVerificationAction.link
        };

        this.entitlementValidationService.createEntitlementValidationRequestRetryAction(validationRequest.id, resourceLink)
          .then(() => this.UserMessages.showToast("TOAST_MESSAGE.VERIFICATION_EMAIL_SENT"))
          .finally(() => this.resendVerificationEmailButtonEnabled = true);
      } else {
        this.resendVerificationEmailButtonEnabled = true;
      }
    }).catch(() => this.resendVerificationEmailButtonEnabled = true);
  }

  private getIdFromLink(link: string) {
    return link.substr(link.lastIndexOf('/') + 1);
  }
}
